// src/components/LoadingScreen.tsx
import React from "react";
import { Loader } from "lucide-react";

interface LoadingScreenProps {
  message?: string;
  fullscreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Chargement...",
  fullscreen = true,
}) => {
  return (
    <div
      className={`${
        fullscreen ? "h-screen" : "min-h-[400px]"
      } flex items-center justify-center`}
    >
      <div className="text-center">
        <Loader className="h-8 w-8 animate-spin text-[#63d400] mx-auto" />
        <p className="text-sm text-gray-500 mt-3">{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
